import { Subtitle } from '@he-novation/config/types/subtitle.types';
import { atom } from 'jotai';

export const subtitlesAtom = atom<Subtitle[]>([]);
export const activeSubtitlesAtom = atom<string[]>([]);
